import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { MainLayoutComponent } from './layouts/main-layout/main-layout.component';
import { ContentComponent } from './pages/content/content.component';
import { BotLayoutComponent } from './layouts/bot-layout/bot-layout.component';
import { FeedbackLayoutComponent } from './layouts/feedback-layout/feedback-layout.component';
import { PodcastLayoutComponent } from './layouts/podcast-layout/podcast-layout.component';
import { DatalabsLayoutComponent } from './layouts/datalabs-layout/datalabs-layout.component';
import { PromptGeneratroLayoutComponent } from './layouts/prompt-generatro-layout/prompt-generatro-layout.component';
import { TranslateLayoutComponent } from './layouts/translate-layout/translate-layout.component';
const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '', component: ContentComponent,
        children: [
          {
            path: '',
            loadChildren: () => import('./pages/genai-home/genai-home.module').then(m => m.GenaiHomeModule)
          },
          {
            path: 'chat',
            loadChildren: () => import('./pages/chat-ai/chat-ai.module').then(m => m.ChatAiModule)
          },
         
          // {
          //   path: 'byod',
          //   loadChildren: () => import('./pages/byod-ai/byod-ai.module').then(m => m.ByodAiModule)
          // },
          // {
          //   path: 'translate',
          //   loadChildren: () => import('./pages/translate-ai/translate-ai.module').then(m => m.TranslateAiModule)
          // },
          // {
          //   path: 'transcribe',
          //   loadChildren: () => import('./pages/transcribe-ai/transcribe-ai.module').then(m => m.TranscribeAiModule)
          // },
        ]
      },
    ]
  },
  {
    path: 'translate',
    component: TranslateLayoutComponent,
    loadChildren: () => import('./pages/translate/translate.module').then(m => m.TranslateModule),
  },
  {
    path: 'podcast-generator',
    component: PodcastLayoutComponent,
    loadChildren: () => import('./pages/podcast-generator/podcast-generator.module').then(m => m.PodcastGeneratorModule),
    
  },
  {
    path: 'datalabs',
    component:DatalabsLayoutComponent,
    loadChildren: () => import('./pages/datalabs/datalabs.module').then(m => m.DatalabsModule),
    
  },
  {
    path: 'prompt-generator',
    component:PromptGeneratroLayoutComponent,
    loadChildren: () => import('./pages/prompt-generator/prompt-generator.module').then(m => m.PromptGeneratorModule),    
  },
  {
    path: 'work',
    component: BotLayoutComponent,
    loadChildren: () => import('./pages/work/work.module').then(m => m.WorkModule),
    
  },
  {
    path: 'feedback',
    component: FeedbackLayoutComponent,
    loadChildren: () => import('./pages/feedback/feedback.module').then(m => m.FeedbackModule),
    
  },
  {
    path: '**', redirectTo: '', pathMatch: 'full' // Fallback route for 404
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      // preloadingStrategy: PreloadAllModules, // Preload all modules to improve navigation speed
      // initialNavigation: 'enabledBlocking' // Optimize initial load time
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
